import type { Level } from "../levels";
import type { Image } from "./image";

export const AuthorStatus = {
  PENDING_IDEA: "pending_idea",
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export type AuthorStatus = (typeof AuthorStatus)[keyof typeof AuthorStatus];

export type Influence = {
  name: string;
  influence: string;
};

export type WritingStyle = {
  inspiredBy: Influence;
  tone: string;
  humorous: boolean;
  vocabulary: string;
  explanation: string;
  sentenceStructure: string;
  exampleUsage: string;
  introductionStyle: string;
  conclusionStyle: string;
};

export type Author = {
  alias: string;
  expertise: {
    category: string;
    subcategory: string;
    subjects: string[];
  };
  tagline: string;
  perspective: string;
  mission: string;
  about: string[];
  targetAudience: {
    expertise: Level;
    description: string;
  };
  influencedBy: Influence;
  writingStyle: WritingStyle;
  aiModel: string;
  status: AuthorStatus;
  profileImage?: Image;
  followerCount: number;
  publishedArticleCount: number;
  createdAt: number;
  updatedAt: number;
};

export type Follow = {
  userId: string;
  authorAlias: string;
  createdAt: number;
  updatedAt: number;
};
